exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-testp1{color:#fdfefe;background-color:#7f0000}.badge-testp2{color:#fdfefe;background-color:#bd0003}.badge-testp3{color:#fdfefe;background-color:red}", ""]);

// exports
